<template>
  <div>
    <!-- 显示头部导航 -->
    <Navbar @inductionApply="inductionApply" @resetPass="resetPass" />
    
    <!-- 无组织页面特殊处理 -->
    <!-- <template v-if="$route.path === '/no-organization/index'">
      <el-container style=" overflow: hidden;">
        <el-main style="padding: 0;">
          <router-view></router-view>
        </el-main>
      </el-container>
    </template> -->
    
    <!-- 其他页面正常布局 -->
    <template >
      <!-- 整体布局容器 -->
      <el-container style=" overflow: hidden;">
        <!-- 侧边栏 -->
        <el-aside width="200px" style="background-color: #545c64;position: fixed;height: 100vh;z-index: 1000;"
          v-if="([100].includes($store.getters.userType))">
          <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" background-color="#545c64"
            text-color="#fff" active-text-color="#ffd04b" :collapse="false">
            <br />
            <el-menu-item index="/invoice/index" @click="$router.push({ path: '/invoice/index' })">
              <span slot="title">订单</span>
            </el-menu-item>
            <el-menu-item index="/invoice/all/list" @click="$router.push({ path: '/invoice/all/list' })">
              <span slot="title">发货单</span>
            </el-menu-item>
            <el-menu-item index="/invoice/logistics/all/list" @click="$router.push({ path: '/invoice/logistics/all/list' });">
              <span slot="title">快递单</span>
            </el-menu-item>
            <el-menu-item index="/invoice/customer" @click="$router.push({ path: '/invoice/customer' })">
              <span slot="title">客户列表</span>
            </el-menu-item>
            <el-menu-item index="/invoice/product/list" @click="$router.push({ path: '/invoice/product/list' })">
              <span slot="title">产品模块列表</span>
            </el-menu-item>
            <el-menu-item index="/invoice/product/machine" @click="$router.push({ path: '/invoice/product/machine' })">
              <span slot="title">成品零件列表</span>
            </el-menu-item>
          </el-menu>
        </el-aside>

        <el-container :style="[100].includes($store.getters.userType) ?
          { 'margin-left': '200px', 'width': 'calc(100% - 200px)' } :
          {}">
          <el-main style="padding: 0;">
            <TopMenu />

            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>

      <InductionApply :show.sync="showInductionApply" />
      <resetPass :show.sync="showresetPass" />
    </template>
    
    <!-- 隐私政策弹窗 -->
    <privacy-dialog
      :visible.sync="showPrivacyDialog"
      @agree="handlePrivacyAgree"
      @cancel="handlePrivacyCancel"
    />
  </div>
</template>

<script>
import Navbar from './components/Navbar'
import TopMenu from "./components/TopMenu"
import InductionApply from "./components/InductionApply"
import resetPass from "./components/resetPass"
import PrivacyDialog from '@/components/PrivacyDialog'
import { getPrivacyStatus, agreePrivacy } from '@/api/privacy'

export default {
  components: { Navbar, TopMenu, InductionApply, resetPass, PrivacyDialog },
  data () {
    return {
      showInductionApply: false,
      showresetPass: false,
      showPrivacyDialog: false,
      privacyChecked: false
    }
  },
  computed: {
    activeIndex() {
      return this.$route.path;
    },
    
  },
  mounted() {
    // 检查隐私政策状态
    this.checkPrivacyStatus();
  },
  methods: {
    inductionApply (e) {
      this.showInductionApply = e
    },
    resetPass(e){
      this.showresetPass = e
    },
    async checkPrivacyStatus() {
      // 避免重复检查
      if (this.privacyChecked) return;
      
      try {
        const response = await getPrivacyStatus();
        if (response.tag === 0) {
          // 如果 info 不是 1，则显示弹窗
          if (response.info !== '1') {
            this.showPrivacyDialog = true;
          }
        } else {
          console.error('获取隐私政策状态失败:', response.msg);
        }
      } catch (error) {
        console.error('请求隐私政策状态失败:', error);
      } finally {
        this.privacyChecked = true;
      }
    },
    async handlePrivacyAgree() {
      try {
        // 调用同意隐私政策接口
        const response = await agreePrivacy();
        if (response.tag === 0) {
          console.log('同意隐私政策成功');
        } else {
          console.error('同意隐私政策失败');
        }
      } catch (error) {
        console.error('同意隐私政策失败:', error);
      }
    },
    async handlePrivacyCancel() {
      // 退出登录逻辑
      this.$router.push('/login');
    }
  }
}
</script>
